import { motion } from "framer-motion";
import { Phone, Mail } from "lucide-react";
import SectionHeading from "components/layout/SectionHeading";
import { contactInfo } from "constants/contact";

const Contact = () => {
  return (
    <section className="flex flex-col gap-12">
      <SectionHeading>Contact Me</SectionHeading>

      <motion.article
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
        whileHover={{ scale: 1.02 }}
        className="flex flex-col items-center gap-8 p-10 border border-gray-300 rounded-3xl shadow-lg shadow-slate-100 bg-gradient-to-br to-gray-100 hover:shadow-2xl transition-all duration-500"
      >
        <motion.a
          href={contactInfo.phoneHref}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          className="flex items-center gap-2 md:gap-4 text-slate-100 hover:text-green-600 cursor-pointer text-2xl font-semibold transition duration-300"
        >
          <Phone className="text-green-200" />
          <span className="text-xl md:text-2xl">{contactInfo.phoneDisplay}</span>
        </motion.a>

        <motion.a
          href={contactInfo.emailHref}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          className="flex items-center gap-2 md:gap-4 text-slate-100 hover:text-green-600 cursor-pointer text-2xl font-semibold transition duration-300"
        >
          <Mail className="text-green-200" />
          <span className="text-xl md:text-2xl">{contactInfo.emailDisplay}</span>
        </motion.a>
      </motion.article>
    </section>
  );
};

export default Contact;
